<template>
  <div>
    <div class="shopping-main ccui-clearfix" v-if="isShowShopHead">
      <shopHead ref="shopHead"></shopHead>
    </div>
    <div class="ccui-app-wrapper">
      <div class="ccui-main-container">
        <!-- 应用导航 -->
        <!--<el-top-nav-menu-3
          ref="topNavMenu"
          :subMenu="menu"
          :appTitle="appTitle"
          :companyTitle="companyTitle"
          dashboard=""
          class="no-print"
          @onSubmitSkip="onJump"
          @ccuiHelp="appHelp"
          :logo="orgLogo"
        >
        </el-top-nav-menu-3>-->

        <!-- 内容区 -->
        <app-main
          class=""
          style="min-height: auto; margin-left: 0;line-break: anywhere;"
        />

        <el-simple-footer
          class="ccui-home-index-footer"
          v-if="isShowSimpleFooter"
        ></el-simple-footer>
        <page-footer v-if="isShowPageFooter"></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { AppMain } from "./components";
import { getGuideCategoryTreeList } from "@/app/shop/api/shopping";
import {
  insertSubconPosterClick,
  selectSubconPosters
} from "@/app/common-modules/api/topnav";
import store from "@/config/store";
import Cookies from "js-cookie";
import arrows from "@/basa/assets/images/arrows.png";
// import slideShows from "@/app/shop/components/slideShows.vue";

// import { getDetail, getLogin } from "@/config/api/login";
// import { getSupInfoByLoginInfo, getUserInfo } from "@/config/api/login";
// import { getArgs } from "@/basa/utils";
import pageFooter from "@/app/shop/components/pageFooter";
import shopHead from "@/app/shop/components/shopHead";
import Vue from "vue";

export default {
  name: "Layout",
  components: {
    AppMain,
    // slideShows,
    pageFooter,
    shopHead
  },
  data() {
    return {
      // imgOptionsA: [],
      companyTitle: "", //组织名称
      appTitle: "", //应用名称
      orgLogo: "",
      arrows,
      counter: 0,
      isShowSidebar: false,
      topMenuObj: {},
      routeMenu: [],
      leftMenu: [],
      subMenuTitle: "",
      currentMenuObj: {},
      currentParentMenuObj: {},
      tempMenu: [],
      activeIndex: "2",
      sidebarPosition: "absolute",
      sidebarMinHeight: "calc(100vh - 40px)",
      isFixed: 100,
      imgs: require("../img/delete.png"),
      catalogList: []
    };
  },
  computed: {
    isShowPageFooter() {
      return this.$store.state.app.isShowPageFooter;
    },
    isShowSimpleFooter() {
      return this.$store.state.app.isShowSimpleFooter;
    },
    isShowShopHead() {
      return this.$store.state.app.isShowShopHead;
    },
    menu() {
      return this.$store.state.app.menu || [];
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened
      };
    },
    currentMenuArr() {
      return this.$store.state.app.currentMenuArr;
    }
  },
  created() {
    this.getDetail();
    this.getCatalog();
    // this.getSwipper();
    // 判断是否展示头部广告
    if (!sessionStorage.getItem("isShowHeaderAd")) {
      this.headVd();
    }
  },
  mounted() {
    if (this.$route.path === "/test/test") {
      return;
    }
    this.setMenuInit();
    this.$nextTick(() => {
      this.$refs.shopHead.init();
    });

    const sidebarStatus = Cookies.get("sidebarStatus") - 0;
    this.isShowSidebar = !!sidebarStatus;

    window.addEventListener("scroll", this.windowScroll);
  },
  watch: {
    $route(to, from) {
      this.setMenuInit();
    },
    "$route.query": {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.__params) {
          const newQuery = this.$crypto.Decrypt(val.__params);
          // 在vue原型上定义一个
          Vue.prototype.$route_query = JSON.parse(newQuery);
          return;
        }
        Vue.prototype.$route_query = val || {};
      }
    }
  },
  methods: {
    // 获取轮播图
    // getSwipper(){
    //   selectSubconPosters({type: 3}).then(res => {
    //     this.imgOptionsA = res.data.data;
    //   })
    // },
    headVd() {
      selectSubconPosters({ type: 2 }).then(res => {
        if (res.data.data && res.data.data.length > 0) {
          let that = this;
          let imgData = res.data.data[0];
          const head = document.createElement("div");
          head.style.backgroundColor = `${imgData.free1}`;
          // 创建 a 标签
          this.isFixed = 200;
          const link = document.createElement("a");
          link.href = imgData.linkUrl;
          link.target = "_blank";
          // 创建 img 标签
          const image = document.createElement("div");
          const imgBox = document.createElement("div");
          const btn = document.createElement("img");
          btn.src = this.imgs;
          btn.style.position = `absolute`;
          btn.style.right = 0;
          imgBox.style.margin = `0 auto`;
          imgBox.style.width = `1180px`;
          imgBox.style.height = `80px`;
          imgBox.style.position = `relative`;
          btn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            image.style.display = "none";
            btn.style.display = "none";
            imgBox.style.display = "none";
            sessionStorage.setItem("isShowHeaderAd", 1);
            that.isFixed = 100;
          });
          if (imgData.isClose === 0) {
            btn.style.display = "none";
          }
          // image.src = imgData.uploadUrl;
          image.style.backgroundImage = `url(${imgData.uploadUrl})`;
          image.style.height = `80px`;
          image.style.backgroundPosition = `50%`;
          image.style.backgroundRepeat = `no-repeat`;
          image.style.backgroundSize = `contain`;
          // image.style.margin = "0 auto";
          // image.style.position = "relative";
          // image.style.minWidth = "1080px";
          // image.style.maxWidth = "1680px";
          // image.style.width = `${width}px`;
          console.log(image.style.width, "image.style.width");
          // 将 img 标签添加到 a 标签中
          link.appendChild(image);
          image.appendChild(imgBox);
          imgBox.appendChild(btn);
          head.appendChild(link);
          head.onclick = function() {
            let subconPosterClickBO = {
              posterId: imgData.id,
              free3: 2,
              free4: localStorage.appToken ? 1 : 0,
              supName: JSON.parse(localStorage.supInfo).supName || ""
            };
            insertSubconPosterClick({ subconPosterClickBO }).then(res => {});
          };
          // 找到网站顶部元素
          const topElement = document.querySelector("body");
          // 插入 a 标签到顶部
          topElement.insertBefore(head, topElement.firstChild);
        }
      });
    },

    appHelp() {
      this.$router.push("/helpAndSupport");
    },
    setMenuInit() {
      this.$store.dispatch("setMenu", this.menu);

      // 这里控制用哪一级路由来定位菜单
      if (this.$route.matched && this.$route.matched.length > 2) {
        this.setMenu(this.$store.state.app.menu, this.$route.matched[1].name); // 四级用三级的name做定位菜单
      } else {
        this.setMenu(this.$store.state.app.menu, this.$route.name); // this.$route.name 用于定位菜单
      }
    },
    getDetail() {
      /*getDetail({ agentId: getArgs("a") }).then(res => {
        if (res.data.code === "0") {
          this.companyTitle = res.data.data.orgFullName;
          // localStorage.setItem("orgFullName", this.companyTitle);
          let agentName = res.data.data.agentName;
          this.orgLogo = res.data.data.orgLogo;
          // 面包屑所用
          this.$store.dispatch("setBreadcrumb", {
            level: "level1",
            data: {
              name: agentName,
              path: "/"
            }
          });
          this.appTitle = agentName;
          this.$store.commit("SET_USER_DETAL", res.data.data);
          sessionStorage.setItem("userDetal", JSON.stringify(res.data.data));
        }
      });
      getLogin({}).then(res => {
        if (res.data.code === "0") {
          this.$store.commit("SET_USER_ID", res.data.data.userId);
        }
      });*/
    },
    //查询导购类目
    getCatalog() {
      if (localStorage.getCatalogList === undefined) {
        getGuideCategoryTreeList({
          agentId: 100131,
          appId: 100131
        }).then(res => {
          if (res.data.code === "0") {
            this.catalogList = res.data.data.guideCategoryTreeNewList;
            store.commit("SET_CATALOG_LIST", this.catalogList);
          }
        });
      } else {
        store.commit("SET_CATALOG_LIST", localStorage.getCatalogList);
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    // 点击菜单
    onJump(obj) {
      this.routeMenu = [];
      this.subMenuTitle = "";
      this.$router.push(obj.url);
    },
    routerObj2MenuObj(item) {
      const menuObj = {};
      menuObj.subMenuTitle = item.name;
      if (item.subMenu.length) {
        const subMenuArr = [];
        item.subMenu.forEach(menuItem => {
          subMenuArr.push(this.trans(menuItem));
        });
        menuObj.subMenu = subMenuArr;
      }
      return menuObj;
    },
    setMenuToRoute(obj) {
      if (obj.subMenu.length) {
        const arr = obj.subMenu;
        const arrMenu = [];

        arr.forEach(item => {
          const menuObj = this.routerObj2MenuObj(item);
          arrMenu.push(menuObj);
        });
        this.$store.dispatch("setCurrentMenuArr", arrMenu);

        this.leftMenu = this.$store.state.app.currentMenuArr;

        this.subMenuTitle = obj.subMenu[0].name;

        const routeObj = this.trans(obj);
        const subMenu = [];
        obj.subMenu.forEach(item => {
          if (item.subMenu.length) {
            item.subMenu.forEach(item => {
              const objTemp = this.trans(item);
              subMenu.push(objTemp);
            });
            routeObj.children = subMenu;
          }
        });

        this.routeMenu = subMenu;
      }
    },
    trans(obj) {
      const _routeObj = {};
      _routeObj.name = obj.name;
      _routeObj.path = obj.url;
      _routeObj.redirect = obj.redirect || "";
      _routeObj.meta = obj.meta || {};
      _routeObj.meta.title = obj.name;
      _routeObj.meta.isNotShow = obj.isNotShow;
      return _routeObj;
    },
    setMenu(arr, menuCode) {
      const that = this;

      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取当前菜单
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
            }
          }
        };
        traverse(arr);
      }
    },
    setParentMenu(arr, pid, index) {
      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取父菜单
              if (arr[i].id === pid) {
                // 获取三级菜单的上级菜单
                if (arr[i].id.split("-").length === 2) {
                  this.currentParentMenuObj = arr[i];
                  arr[i].activeIndex = index;
                  // return
                }
                // 获取二级菜单的上级菜单
                if (arr[i].id.split("-").length === 1) {
                  arr[i].activeIndex = index;
                }

                // 设置上级菜单
                this.setParentMenu(this.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].id === pid) {
                arr[i].activeIndex = index;
              }
            }
          }
        };
        traverse(arr);
      }

      if (
        this.currentParentMenuObj.subMenu &&
        this.currentParentMenuObj.subMenu.length
      ) {
        this.setMenuToRoute(this.currentParentMenuObj);
      }
    },
    windowScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.sidebarPosition = scrollTop >= this.isFixed ? "fixed" : "absolute";
      // this.sidebarPosition = scrollTop >= 120 ? "fixed" : "absolute";
      // this.sidebarMinHeight =
      //   scrollTop >= 120
      //     ? "calc(100vh - 40px)"
      //     : `calc(100vh - ${160 - scrollTop}px)`;
    }
  }
};
</script>
